import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  InputAdornment,
  IconButton,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import PersonIcon from "@mui/icons-material/Person";
import BusinessIcon from "@mui/icons-material/Business";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const UserLogin = ({ onBack, onLoginSuccess }) => {
  const [studioName, setStudioName] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const res = await axios.post("https://studio-lc.onrender.com/api/clients/login", {
        studioName: studioName.trim(),
        username,
        password,
      });
      localStorage.setItem("userId", res.data.userId);
      localStorage.setItem("clientMongoId", res.data.studioId);
      localStorage.setItem("username", res.data.username);
      localStorage.setItem("mobile", res.data.mobile);
      if (onLoginSuccess) onLoginSuccess();
    } catch (err) {
      setError(
        err.response?.data?.error || "Login failed. Please try again."
      );
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: `url('https://wallpaperaccess.com/full/634030.jpg')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Paper
        elevation={8}
        sx={{
          p: { xs: 3, sm: 5 },
          borderRadius: 5,
          maxWidth: 400,
          width: "100%",
          background: "linear-gradient(135deg, #fffde7 0%, #e3f2fd 100%)",
          boxShadow: "0 8px 32px #a67c5233",
        }}
      >
        <Box sx={{ textAlign: "center", mb: 2 }}>
          <LockIcon sx={{ fontSize: 48, color: "#a67c52", mb: 1 }} />
          <Typography
            variant="h4"
            fontWeight="bold"
            sx={{
              fontFamily: "Josefin Sans",
              color: "#8b5e3c",
              mb: 1,
              letterSpacing: 2,
            }}
          >
            User Login
          </Typography>
          <Typography sx={{ color: "#888", fontSize: 16, fontFamily: "Jost" }}>
            Enter your studio, username and password to continue
          </Typography>
        </Box>
        <Box
          component="form"
          onSubmit={handleSubmit}
          display="flex"
          flexDirection="column"
          gap={2}
        >
          <TextField
            label="Studio Name"
            variant="outlined"
            value={studioName}
            onChange={(e) => setStudioName(e.target.value)}
            required
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <BusinessIcon sx={{ color: "#a67c52" }} />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Username"
            variant="outlined"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PersonIcon sx={{ color: "#a67c52" }} />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Password"
            variant="outlined"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockIcon sx={{ color: "#a67c52" }} />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label={showPassword ? "Hide password" : "Show password"}
                    onClick={() => setShowPassword((show) => !show)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          {error && (
            <Typography
              color="error"
              sx={{ textAlign: "center", fontWeight: 600 }}
            >
              {error}
            </Typography>
          )}
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{
              bgcolor: "#a67c52",
              fontFamily: "Josefin Sans",
              color: "#fff",
              fontWeight: 700,
              fontSize: 18,
              py: 1.2,
              borderRadius: 3,
              boxShadow: 2,
              "&:hover": { bgcolor: "#8b5e3c" },
            }}
          >
            Login
          </Button>
          <Button
            variant="text"
            color="secondary"
            fullWidth
            startIcon={<ArrowBackIcon />}
            onClick={onBack}
            sx={{
              mt: 1,
              color: "#a67c52",
              fontFamily: "Josefin Sans",
              fontWeight: 700,
              fontSize: 16,
              "&:hover": { bgcolor: "#fffde7" },
            }}
          >
            Back
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default UserLogin;